import React, { useEffect, useState,Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat, getDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing-expenses'
import ActionIconButton from '../../components/Actions/ActionIconButton';
import EditIcon from '@material-ui/icons/Edit';
import ColumnActions from '../../components/Actions/ColumnActions';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { trackDwebEvent } from '../../analytics';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import DeleteIcon from '@material-ui/icons/Delete';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ActionButton from '../../components/Actions/ActionButton';
import queryString from "query-string";
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import { getPaymentStatus } from '../../../store/actions/OnlinePaymentActionCreators';
import { getAllPnlMonths } from '../../../store/actions/homeActionCreator';
import FilterComponent from '../../components/FilterComponent/FilterComponent';
import moment from 'moment';
import { Waypoint } from "react-waypoint";
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { 
    getPNLExpenses,
    getTotalMonthExpense,
    getTruckExpenses,
    getTripExpenses,
    getOfficeExpenses,
    getAllVehicleExpense,
    getAllTripExpenseTypes,
    getAllOfficeExpenseTypes,
    getOfficeExpenseSingle,
} from '../../../store/actions/expensesActionCreators';
import TopCard from '../../components/TopCard/TopCard'
import ExpensesSparkline from './ExpensesSparkline';
import { EmptyStateTruck,EmptyStateTrip,EmptyStateOffice,EmptyStateOfficeHeader } from './expensesIcons';
import EmptyStateOffice1 from './emptyStateOffice.svg';
import HeaderOfficeIcon from './HeaderOfficeIcon.svg';
import InputBase from '@material-ui/core/InputBase';
import CloseIcon from '@material-ui/icons/Close';
import AddTruckExpenseDialog from '../../components/VehicleDialogs/AddTruckExpenseDialog';
import TransactionDetailsSideBar from '../../components/RightSideBar/TransactionDetailsSideBar';
import ExpenseDetailsCard from '../../components/Payment/ExpenseDetailsCard';
import { getVendorExpense } from '../../../store/actions/tripActionCreator';
import AddTripExpenseDialog from '../../components/VehicleDialogs/AddTripExpenseDialog';
import AddOfficeExpenseDialog from '../../components/VehicleDialogs/AddOfficeExpenseDialog';
import DeleteOfficeExpenseDialog from '../../components/VehicleDialogs/DeleteOfficeExpenseDialog';
import DeleteExpenseDialog from '../../components/VehicleDialogs/DeleteExpenseDialog';
import ReportsDialog from '../../components/ReportsDialog/ReportsDialog';
import ExpenseInfoCard from '../../components/Payment/ExpenseInfoCard';
import VehicleNumberFormat from './VehicleNumberFormat';
const formatMonth = (date) => {

    let dateArray=[];

    if (date && date.includes("-")) {
        dateArray = date.split("-");
    } else {
        //dateArray = date.split(" ");
    }

    let month = dateArray && dateArray[0] ? dateArray[0] : ""

    switch (month.toLowerCase()) {
        case 'jan': month = "January"; break;
        case 'feb': month = "February"; break;
        case 'mar': month = "March"; break;
        case 'apr': month = "April"; break;
        case 'may': month = "May"; break;
        case 'jun': month = "June"; break;
        case 'jul': month = "July"; break;
        case 'aug': month = "August"; break;
        case 'sep': month = "September"; break;
        case 'oct': month = "October"; break;
        case 'nov': month = "November"; break;
        case 'dec': month = "December"; break;
    }

    let finalDate = month;
    return finalDate;
}
const Expenses = ({ 
    user, 
    expenses, 
    dispatchGetPaymentStatus,
    dispatchGetPnlMonths,
    dispatchGetPnlExpenses,
    dispatchGetTotalMonthExpense,
    dispatchGetOfficeExpenses,
    dispatchGetTripExpenses,
    dispatchGetTruckExpenses,
    dispatchGetAllVehicleExpense,
    dispatchGetVendorExpense,
    dispatchGetAllTripExpense,
    dispatchGetAllOfficeExpenseTypes,
    dispatchGetOfficeExpense
}) => {
    const executeScrollAll = () => {
        let el = document.getElementById('expenses-list-box-truck');
        let el1 = document.getElementById('expenses-list-box-trip');
        let el2 = document.getElementById('expenses-list-box-office');
        if(el)
            el.scrollTop = 0;
        if(el1)
            el1.scrollTop = 0;
        if(el2)
            el2.scrollTop = 0;
    }
    const executeScrollType = (type) => {
        let el = document.getElementById(`expenses-list-box-${type}`);
        if(el)
            el.scrollTop = 0;
    }
    const classes = useStyles();
    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    let defaultMonth = moment().format('MMMM-YYYY');
    const [searchTextVehicle, setSearchTextVehicle] = useState("");
    const [searchTextTrip, setSearchTextTrip] = useState("");
    const [searchTextOffice, setSearchTextOffice] = useState("");
    const [initialTruckEmpty, setInitialTruckEmpty] = useState(false);
    const [initialTripEmpty, setInitialTripEmpty] = useState(false);
    const [initialOfficeEmpty, setInitialOfficeEmpty] = useState(false);
    const [monthFilterValue, setMonthFilterValue] = useState(defaultMonth);
    const [defaultData, setDefaultData] = useState(null);
    const [selectedExpenseData, setSelectedExpenseData] = useState(null);
    const [selectedBoxData, setSelectedBoxData] = useState(null)
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [currentPageNoVehicle, setCurrentPageNoVehicle] = useState(1);
    const [currentPageSizeVehicle, setCurrentPageSizeVehicle] = useState(10);
    const [currentPageNoTrip, setCurrentPageNoTrip] = useState(1);
    const [currentPageSizeTrip, setCurrentPageSizeTrip] = useState(10);
    const [currentPageNoOffice, setCurrentPageNoOffice] = useState(1);
    const [currentPageSizeOffice, setCurrentPageSizeOffice] = useState(10);
    const [addTruckExpenseDialogOpen, setAddTruckExpenseDialogOpen] = useState(false);
    const [detailsOpen,setDetailsOpen] = useState(false);
    const [addTripExpenseDialogOpen, setAddTripExpenseDialogOpen] = useState(false);
    const [addOfficeExpenseDialogOpen, setAddOfficeExpenseDialogOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    const [deleteOfficeExpenseDialogOpen, setOfficeDeleteExpenseDialogOpen] = useState(false);
    const [deleteExpenseDialogOpen, setDeleteExpenseDialogOpen] = useState(false);
    const [pdfDialogOpen, setPdfDialogOpen] = useState(false);

    let boxes=[
        {
            actionName:'Add Truck Expense',
            name:'Truck Expenses',
            headerLabel:`${formatMonth(monthFilterValue)} Truck Expenses`,
            searchPlacHolder:"Search Truck Expense",
            type:'truck',
            actionBg:'#1d96a7',
            headerBg:'#faebcb',
            headerIcon:<EmptyStateTruck className={classes.headerIcon} />,
            emptyStateIcon:<EmptyStateTruck className={classes.emptyStateIcon} />,
            emptyStateTitle:'No Truck Expense',
            emptyStateSubTitle:<span>You have not added any Truck expense for<br />this month</span>,
            listData:expenses&&expenses.vehicleExpenses&&expenses.vehicleExpenses.expenses?expenses.vehicleExpenses:[],
            show:initialTruckEmpty?false:true
        },
        {
            actionName:'Add Trip Expense',
            name:'Trip Expenses',
            headerLabel:`${formatMonth(monthFilterValue)} Trip Expenses`,
            type:'trip',
            searchPlacHolder:"Search Trip Expense",
            actionBg:'#1da779',
            headerBg:'#e1fff2',
            headerIcon:<EmptyStateTrip className={classes.headerIcon} />,
            emptyStateIcon:<EmptyStateTrip className={classes.emptyStateIcon} />,
            emptyStateTitle:'No Trip Expense',
            emptyStateSubTitle:<span>You have not added any Trip expense for<br />this month</span>,
            listData:expenses&&expenses.tripExpenses&&expenses.tripExpenses.expenses?expenses.tripExpenses:[],
            show:initialTripEmpty?false:true
        },
        {
            actionName:'Add Office Expense',
            searchPlacHolder:"Search Office Expense",
            name:'Office Expenses',
            headerLabel:`${formatMonth(monthFilterValue)} Office Expenses`,
            type:'office',
            actionBg:'#c06e22',
            headerBg:'#f1f1f3',
            headerIcon:<img src={HeaderOfficeIcon}/>,
            emptyStateIcon:<img src={EmptyStateOffice1}/>,
            emptyStateTitle:'No Office Expense',
            emptyStateSubTitle:<span>You have not added any Office expense for<br />this month</span>,
            listData:expenses&&expenses.officeExpenses&&expenses.officeExpenses.expenses?expenses.officeExpenses:[],
            show:initialOfficeEmpty?false:true
        }
    ]
    //Use Effect Hooks
    useEffect(() => {
        trackDwebEvent('Dweb Expenses page', {});
        dispatchGetPnlMonths(
            (data) => {
                if(data && data.status && data.status.code && data.status.code == 200){
                    setMonthFilterValue(data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : "");
                    let req = {
                        monthYear:data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : "",
                        pageNo:defaultPageNo,
                        pageSize:defaultPageSize
                    }
                    loadInitialData(data && data.response && data.response.months && data.response.months[0] ? data.response.months[0] : "")
                }
            },
            () => {

            }
        );
    }, []);

    //Handle Actions
    const boxActionCall = (req,box)=>{
        if (box && box.type && box.type=='truck') {
            setCurrentPageNoVehicle(defaultPageNo)
            dispatchGetTruckExpenses(
                req,
                (truck) => {
                    if(truck && truck.status && truck.status.code && truck.status.code == 200){
                        
                    }
                },
                () => {
    
                }
            )
        }
        if (box && box.type && box.type=='trip') {
            setCurrentPageNoTrip(defaultPageNo);
            dispatchGetTripExpenses(
                req,
                (trip) => {
                    if(trip && trip.status && trip.status.code && trip.status.code == 200){
                        
                    }
                },
                () => {
    
                }
            ) 
        }
        if (box && box.type && box.type=='office') {
            setCurrentPageNoOffice(defaultPageNo);
            dispatchGetOfficeExpenses(
                req,
                (office) => {
                    if(office && office.status && office.status.code && office.status.code == 200){
                        
                    }
                },
                () => {
    
                }
            )
        }
    }
    const onSearchBlur = debounce((query,box) => {
        let req = {
            monthYear:monthFilterValue ? monthFilterValue : "",
            pageNo:defaultPageNo,
            pageSize:defaultPageSize,
            searchText:query
        }
        boxActionCall(req,box)
        executeScrollType(box.type);
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
    const loadInitialData = (month)=>{
        executeScrollAll()
        let req = {
            monthYear:month ? month : "",
            pageNo:defaultPageNo,
            pageSize:defaultPageSize
        }
        dispatchGetPnlExpenses(
            req,
            (pnl) => {
                if(pnl && pnl.status && pnl.status.code && pnl.status.code == 200){
                    dispatchGetTotalMonthExpense(
                        req,
                        (total) => {
                            if(total && total.status && total.status.code && total.status.code == 200){
                                if(searchTextVehicle)
                                   req.searchText = searchTextVehicle
                                else
                                    delete req.searchText
                                dispatchGetTruckExpenses(
                                    req,
                                    (truck) => {
                                        if(truck && truck.status && truck.status.code && truck.status.code == 200){
                                            if(truck && truck.response && truck.response.expenses && truck.response.expenses.length > 0){
                                                setInitialTruckEmpty(false)
                                            }else{
                                                setInitialTruckEmpty(true)
                                            }
                                            if(searchTextTrip)
                                                req.searchText = searchTextTrip
                                            else
                                                delete req.searchText
                                            dispatchGetTripExpenses(
                                                req,
                                                (trip) => {
                                                    if(trip && trip.status && trip.status.code && trip.status.code == 200){
                                                        if(trip && trip.response && trip.response.expenses && trip.response.expenses.length > 0){
                                                            setInitialTripEmpty(false)
                                                        }else{
                                                            setInitialTripEmpty(true)
                                                        }
                                                        if(searchTextOffice)
                                                            req.searchText = searchTextOffice
                                                        else
                                                            delete req.searchText
                                                        dispatchGetOfficeExpenses(
                                                            req,
                                                            (office) => {
                                                                if(office && office.status && office.status.code && office.status.code == 200){
                                                                    if(office && office.response && office.response.expenses && office.response.expenses.length > 0){
                                                                        setInitialOfficeEmpty(false)
                                                                    }else{
                                                                        setInitialOfficeEmpty(true)
                                                                    }
                                                                }
                                                            },
                                                            () => {
                                                
                                                            }
                                                        )
                                                    }
                                                },
                                                () => {
                                    
                                                }
                                            ) 
                                        }
                                    },
                                    () => {
                        
                                    }
                                )
                            }
                        },
                        () => {
            
                        }
                    )
                }
            },
            () => {

            }
        )
    }
    const handleTransactionDetailsClose = () => {
        setEdit(false);
        setSelectedExpenseData(null);
        setDetailsOpen(false)
        loadInitialData(monthFilterValue)
    }
    const getPaginatedData = (box) => {
        let req = {
            monthYear:monthFilterValue ? monthFilterValue : "",
            pageNo:defaultPageNo,
            pageSize:defaultPageSize,
            merge:true,
        }
        if (box && box.type && box.type=='truck' && box.listData && box.listData.maxPage &&  box.listData.maxPage != currentPageNoVehicle) {
            setCurrentPageNoVehicle(currentPageNoVehicle + 1)
            req.pageNo = currentPageNoVehicle + 1;
            req.searchText = searchTextVehicle;
            dispatchGetTruckExpenses(
                req,
                (truck) => {
                    if(truck && truck.status && truck.status.code && truck.status.code == 200){
                        
                    }
                },
                () => {
    
                }
            )
        }
        if (box && box.type && box.type=='trip' && box.listData && box.listData.maxPage &&  box.listData.maxPage != currentPageNoTrip) {
            setCurrentPageNoTrip(currentPageNoTrip + 1);
            req.pageNo = currentPageNoTrip + 1;
            req.searchText = searchTextTrip;
            dispatchGetTripExpenses(
                req,
                (trip) => {
                    if(trip && trip.status && trip.status.code && trip.status.code == 200){
                        
                    }
                },
                () => {
    
                }
            ) 
        }
        if (box && box.type && box.type=='office' && box.listData && box.listData.maxPage &&  box.listData.maxPage != currentPageNoOffice) {
            setCurrentPageNoOffice(currentPageNoOffice + 1);
            req.pageNo = currentPageNoOffice + 1;
            req.searchText = searchTextOffice;
            dispatchGetOfficeExpenses(
                req,
                (office) => {
                    if(office && office.status && office.status.code && office.status.code == 200){
                        
                    }
                },
                () => {
    
                }
            )
        }
    }
    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = (data) => {
        setSuccessCreation(false)
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = (data) => {
        setFailureCreation(false)
    }
    const handleMonthFilter = (dateValue) => {
        setMonthFilterValue(dateValue);
        loadInitialData(dateValue)
    }
    const createExpBox = (box,exp,index)=>{
        return (<Box key={index} display={'flex'} justifyContent={'space-between'} width={'100%'} marginBottom={'8px'} className={classes.expBox} onClick={()=>{handleCardClick(box,exp)}}>
            <Box display={'flex'} alignItems={'center'}>
                {exp && exp.iconUrl &&<Box component={'div'} className={classes.listIconBox}>
                    <img width={'24px'} height={'24px'} src={exp.iconUrl}  />
                </Box>}
                <div>
                    <Box display={'flex'} alignItems={'center'}>
                        <Typography className={classes.listValueName}>{exp.expenseName}</Typography>
                        {box && box.type=='trip'&&<>
                            <FiberManualRecordIcon className={classes.expBullet} />
                            <Typography className={classes.expDate}>{exp.expenseDate}</Typography>
                        </>}
                    </Box>
                    <Box display={'flex'} alignItems={'center'} marginTop={'2px'}>
                        {box && box.type=='truck'&&<>
                            <Typography className={classes.expDate}>{exp.expenseDate}</Typography>
                            <FiberManualRecordIcon className={classes.expBullet} />
                            {exp.vehicleNumber && <VehicleNumberFormat value={exp.vehicleNumber} size={10} color={'##1a1a1a'} />}
                        </>}
                        {box && box.type=='office'&&<>
                            <Typography className={classes.expDate}>{exp.expenseDate}</Typography>
                            {exp && exp.expenseDescription&&<>
                            <FiberManualRecordIcon className={classes.expBullet} />
                            <Typography className={classes.expenseDescription}>{`"${exp.expenseDescription}"`}</Typography>
                        </>}
                        </>}
                        {box && box.type=='trip'&&<>
                            <Typography className={classes.expRoute}>{exp.tripRoute}</Typography>
                        </>}
                    </Box>
                </div>
            </Box>
            <Typography className={classes.listValueAmount}>{numberFormat(exp.amount)}</Typography>
        </Box>)
    }
    const handleCardClick = (box,exp)=>{
        setSelectedBoxData(box)
        if(exp&&exp.expenseId){
            if(box && box.type && box.type=='office'){
                dispatchGetOfficeExpense(exp.expenseId,(data)=>{
                    if(data && data.status && data.status.code && data.status.code == 200){
                        setSelectedExpenseData({
                            ...exp,
                            ...data.response
                        });
                        setDetailsOpen(true);
    
                        if(box && box.type && box.type=='truck'){
                        }else if(box && box.type && box.type=='trip'){
                        }else if(box && box.type && box.type=='office'){
                        }
                    }
                },()=>{
    
                })
            }else{
                dispatchGetVendorExpense(exp.expenseId,(data)=>{
                    if(data && data.status && data.status.code && data.status.code == 200){
                        setSelectedExpenseData({
                            ...exp,
                            ...data.response
                        });
                        setDetailsOpen(true);
    
                        if(box && box.type && box.type=='truck'){
                        }else if(box && box.type && box.type=='trip'){
                        }else if(box && box.type && box.type=='office'){
                        }
                    }
                },()=>{
    
                })
            }
        }
    }
    const handleEditExpense = (box,exp)=>{
        setSelectedBoxData(box)
        if(exp&&exp.expenseId){
            if(box && box.type && box.type=='office'){
                dispatchGetOfficeExpense(exp.expenseId,(data)=>{
                    if(data && data.status && data.status.code && data.status.code == 200){
                        setSelectedExpenseData({
                            ...exp,
                            ...data.response
                        });
                        setAddOfficeExpenseDialogOpen(true)
                        setEdit(true)
                    }
                },()=>{
    
                })
            }else{
                if(exp && exp.expenseParentType && exp.expenseParentType=='fastag'){

                }else{
                    dispatchGetVendorExpense(exp.expenseId,(data)=>{
                        if(data && data.status && data.status.code && data.status.code == 200){
                            setSelectedExpenseData({
                                ...exp,
                                ...data.response
                            });    
                            if(box && box.type && box.type=='truck'){
                                setAddTruckExpenseDialogOpen(true)
                            }else if(box && box.type && box.type=='trip'){
                                setAddTripExpenseDialogOpen(true)
                            }else if(box && box.type && box.type=='office'){
                            }
                            setEdit(true)
                        }
                    },()=>{
        
                    })
                }
                
            }
        }
    }
    const handleEmptySearchText = (box)=>{
        if(box && box.type && box.type=='truck'){
            setSearchTextVehicle('');
        }else if(box && box.type && box.type=='trip'){
            setSearchTextTrip('');
        }else if(box && box.type && box.type=='office'){
            setSearchTextOffice('');
        }
        if (box && box.type) {
            onSearchBlur(null,box);
        }
    }
    const handleSetSearchText = (box,value)=>{
        if(box && box.type && box.type=='truck'){
            setSearchTextVehicle(value);
        }else if(box && box.type && box.type=='trip'){
            setSearchTextTrip(value);
        }else if(box && box.type && box.type=='office'){
            setSearchTextOffice(value);
        }
        if (box && box.type) {
            let req = {
                monthYear:monthFilterValue ? monthFilterValue : "",
                pageNo:defaultPageNo,
                pageSize:defaultPageSize,
            }
            onSearchBlur(value,box)
        }
    }
    const handleAddAction = (box)=>{
        setSelectedBoxData(box)
        if(box && box.type && box.type=='truck'){
            dispatchGetAllVehicleExpense((data)=>{
                if(data && data.status && data.status.code && data.status.code == 200){
                    setAddTruckExpenseDialogOpen(true);
                }
            },()=>{

            })
        }else if(box && box.type && box.type=='trip'){
            dispatchGetAllTripExpense((data)=>{
                if(data && data.status && data.status.code && data.status.code == 200){
                    setAddTripExpenseDialogOpen(true);
                }
            },()=>{

            })
        }else if(box && box.type && box.type=='office'){
            dispatchGetAllOfficeExpenseTypes((data)=>{
                if(data && data.status && data.status.code && data.status.code == 200){
                    setAddOfficeExpenseDialogOpen(true);
                }
            },()=>{

            })
        }
    }
    const getSearchText = (box)=>{
        let txt = ''
        switch (box.type) {
            case 'truck':txt=searchTextVehicle; break;
            case 'trip': txt=searchTextTrip; break;
            case 'office': txt=searchTextOffice; break;
        }
        return txt
    }
    const handleAddTruckExpenseClose = () => {
        setEdit(false)
        setAddTruckExpenseDialogOpen(false);
        loadInitialData(monthFilterValue)
    }
    const handleAddTruckExpenseConfirm = (month) => {
        emptyOfData()
        setAddTruckExpenseDialogOpen(false);
        setMonthFilterValue(month);
        loadInitialData(month)
    }
    const handleAddTripExpenseClose = () => {
        setEdit(false)
        setAddTripExpenseDialogOpen(false);
        loadInitialData(monthFilterValue)
    }
    const handleAddTripExpenseConfirm = (month) => {
        emptyOfData()
        setAddTripExpenseDialogOpen(false);
        setMonthFilterValue(month);
        loadInitialData(month)
    }
    const handleAddOfficeExpenseClose = () => {
        setEdit(false)
        setAddOfficeExpenseDialogOpen(false);
        loadInitialData(monthFilterValue)
    }
    const handleAddOfficeExpenseConfirm = (month) => {
        emptyOfData()
        setAddOfficeExpenseDialogOpen(false);
        setMonthFilterValue(month);
        loadInitialData(month)
    }
    const emptyOfData = ()=>{
        setDetailsOpen(false)
        setSelectedBoxData(null)
        setSelectedExpenseData(null)
        setEdit(false);
    }
    const handleOfficeExpenseDeleteClose = () => {
        setOfficeDeleteExpenseDialogOpen(false);
    }

    const handleOfficeDeleteExpenseConfirm = () => {
        setOfficeDeleteExpenseDialogOpen(false);
        emptyOfData()
        loadInitialData(monthFilterValue)
    }
    const handleExpenseDeleteClose = () => {
        setDeleteExpenseDialogOpen(false);
    }

    const handleDeleteExpenseConfirm = () => {
        setDeleteExpenseDialogOpen(false);
        emptyOfData()
        loadInitialData(monthFilterValue)
    }
    const handleClosePdf = () => {
        loadInitialData(monthFilterValue)
        setPdfDialogOpen(false);
    }
    const handleViewPdf = () => {
        setPdfDialogOpen(true);
    }
    return (
        <>
            <Wrapper>
                <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.topGrid}>
                        <div className={classes.divFilter}>
                            {monthFilterValue && <FilterComponent defaultValue={monthFilterValue} value={monthFilterValue} reportType={"expenses"} pnlDate={handleMonthFilter} />}
                        </div>
                        <div className={classes.divSparkline}>
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} className={classes.topGrid}>
                                <TopCard widthNone={true} heightNone={true} title='TOTAL MONTH EXPENSE' infoTitle='TOTAL MONTH EXPENSE' infoText='Expenses Total Amount'
                                color="#fa0000" infoIcon={true} cardValue={numberFormat(expenses && expenses.sparkline && expenses.sparkline.totalAmount ? expenses.sparkline.totalAmount : 0)} 
                                />
                                <ExpensesSparkline pnlValues={expenses&&expenses.pnlData?expenses.pnlData:null} viewPdfAction={handleViewPdf} />
                            </Box>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {boxes && boxes.map((box,index)=>{
                                return <Grid item xs={4} key={index}>
                                    {box.show?
                                    <Box display={'flex'} flexDirection={'column'} className={classes.listStateBox}>
                                        <Box display={'flex'} alignItems={'center'} className={classes.headerBox}>
                                            <Box component={'div'} className={classes.iconBox} style={{backgroundColor:box.headerBg}}>
                                                {box.headerIcon}
                                            </Box>
                                            <Typography className={classes.headerTitle}>{box.name}</Typography>
                                        </Box>
                                        <Box width={'100%'} marginTop={'16px'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} className={classes.expActionBox}>
                                            <Box component={'div'}  display={'flex'} flexDirection={'column'}>
                                                <Typography className={classes.headerLabel}>{box.headerLabel}</Typography>
                                                <Typography className={classes.headerAmount}>{numberFormat(box.listData&&box.listData.totalMonthExpense?box.listData.totalMonthExpense:0)}</Typography>
                                            </Box>
                                            <Button style={{backgroundColor:box.actionBg}} variant="contained" classes={{ root: classes.listStateCta }} onClick={() => {handleAddAction(box)}}>
                                                {box.actionName}
                                            </Button>
                                        </Box>
                                        <Box component={'div'} className={classes.search} key={index}>
                                            {!getSearchText(box) && <div className={classes.searchIcon}>
                                            <SearchIcon className={classes.sicon} />
                                            </div>}
                                            {getSearchText(box) && <div className={classes.closeIcon} onClick={(e) => { handleEmptySearchText(box) }}>
                                            <CloseIcon className={classes.sicon} />
                                            </div>}
                                            <InputBase
                                            placeholder={box.searchPlacHolder}
                                            value={getSearchText(box)}
                                            classes={{
                                                root: classes.inputRoot,
                                                input: classes.inputInput,
                                            }}
                                            onChange={(e) => { handleSetSearchText(box,e.target.value) }}
                                            inputProps={{ 'aria-label': 'search' }}
                                            />
                                        </Box>
                                        <Box display={'flex'} flexDirection={'column'} id={`expenses-list-box-${box.type}`} className={classes.listBox}>
                                            {box.listData.expenses && box.listData.expenses.map((exp,index)=>{
                                                if (index === box.listData.expenses.length - 1) {
                                                    return (
                                                      <Fragment>
                                                        <Waypoint
                                                          onEnter={() => {
                                                            getPaginatedData(box)                                                            
                                                          }}
                                                        />
                                                        {createExpBox(box,exp,index)}
                                                      </Fragment>
                                                    );
                                                  } else {
                                                    return <Fragment>{createExpBox(box,exp,index)}</Fragment>;
                                                  }
                                            })}
                                        </Box>
                                    </Box>
                                    :<Box display={'flex'} alignItems={'center'} justifyContent={'center'} flexDirection={'column'}  className={classes.emptyStateBox}>
                                        {box.emptyStateIcon}
                                        <Typography className={classes.emptyStateTitle}>{box.emptyStateTitle}</Typography>
                                        <Typography className={classes.emptyStateSubTitle}>{box.emptyStateSubTitle}</Typography>
                                        <Button style={{backgroundColor:box.actionBg}} variant="contained" classes={{ root: classes.emptyStateCta }} onClick={() => {handleAddAction(box)}}>
                                            {box.actionName}
                                        </Button>
                                    </Box>}
                                </Grid>
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </Wrapper>
            {successCreation && <SuccessDialog selectedValue={defaultData} open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog selectedValue={defaultData} open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            {addTruckExpenseDialogOpen && <AddTruckExpenseDialog edit={selectedExpenseData && selectedExpenseData.id ? true:false} expenseData={selectedExpenseData} expenseId={selectedExpenseData && selectedExpenseData.id ? selectedExpenseData.id:null} selectedBox={selectedBoxData} open={addTruckExpenseDialogOpen} onClose={handleAddTruckExpenseClose} onConfirm={handleAddTruckExpenseConfirm} />}
            {addTripExpenseDialogOpen && <AddTripExpenseDialog edit={selectedExpenseData && selectedExpenseData.id ? true:false} expenseData={selectedExpenseData} expenseId={selectedExpenseData && selectedExpenseData.id ? selectedExpenseData.id:null} selectedBox={selectedBoxData} open={addTripExpenseDialogOpen} onClose={handleAddTripExpenseClose} onConfirm={handleAddTripExpenseConfirm} />}
            {addOfficeExpenseDialogOpen && <AddOfficeExpenseDialog edit={selectedExpenseData && selectedExpenseData.id ? true:false} expenseData={selectedExpenseData} expenseId={selectedExpenseData && selectedExpenseData.id ? selectedExpenseData.id:null} selectedBox={selectedBoxData} open={addOfficeExpenseDialogOpen} onClose={handleAddOfficeExpenseClose} onConfirm={handleAddOfficeExpenseConfirm} />}
            {detailsOpen && <TransactionDetailsSideBar
                rightSideBarOpen={detailsOpen}
                sideBarTitle={selectedExpenseData&&selectedExpenseData.expenseName?selectedExpenseData.expenseName:'Expense Details'}
                data={selectedExpenseData}
                cStyle={true}
                onEdit={selectedExpenseData && !selectedExpenseData.id ? null :selectedExpenseData&&selectedExpenseData.expenseParentType&&selectedExpenseData.expenseParentType=='fastag'?null:(data) => {
                    handleEditExpense(selectedBoxData,selectedExpenseData)
                }}
                onDelete={selectedExpenseData && !selectedExpenseData.id ? null :selectedExpenseData&&selectedExpenseData.expenseParentType&&selectedExpenseData.expenseParentType=='fastag'?null: (data) => {
                    if(selectedBoxData && selectedBoxData.type && selectedBoxData.type=='truck'){
                        setDeleteExpenseDialogOpen(true)
                    }else if(selectedBoxData && selectedBoxData.type && selectedBoxData.type=='trip'){
                        setDeleteExpenseDialogOpen(true)
                    }else if(selectedBoxData && selectedBoxData.type && selectedBoxData.type=='office'){
                        setOfficeDeleteExpenseDialogOpen(true)
                    }
                }}
                //sideBarSecondaryTitle={null}
                handleSubmit={event => { }}
                toggleRightSideBar={handleTransactionDetailsClose}
            >
                <ExpenseDetailsCard
                    data={selectedExpenseData}
                    type={selectedExpenseData && selectedExpenseData.entityType ? selectedExpenseData.entityType : null}
                />
                {selectedExpenseData && selectedExpenseData.id && selectedBoxData.type!='office' && <ExpenseInfoCard
                    data={selectedExpenseData}
                    type={selectedExpenseData && selectedExpenseData.entityType ? selectedExpenseData.entityType : null}
                />}
            </TransactionDetailsSideBar>}
            {deleteOfficeExpenseDialogOpen && <DeleteOfficeExpenseDialog open={deleteOfficeExpenseDialogOpen} onClose={handleOfficeExpenseDeleteClose} onConfirm={handleOfficeDeleteExpenseConfirm} expenseId={selectedExpenseData && selectedExpenseData.id ? selectedExpenseData.id:null} />}
            {deleteExpenseDialogOpen && <DeleteExpenseDialog open={deleteExpenseDialogOpen} onClose={handleExpenseDeleteClose} onConfirm={handleDeleteExpenseConfirm} expenseId={selectedExpenseData && selectedExpenseData.id ? selectedExpenseData.id:null} />}
            {
                pdfDialogOpen &&
                <ReportsDialog open={pdfDialogOpen} name={"Profit and Loss Report"} pdfMonth={monthFilterValue} onClose={handleClosePdf} reportType={"excelReports"} />
            }
        </>
    );
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetPnlMonths: (onSuccess, onError) => {
        dispatch(getAllPnlMonths(null, onSuccess, onError))
    },
    dispatchGetPnlExpenses: (data,onSuccess, onError) => {
        dispatch(getPNLExpenses(data, onSuccess, onError))
    },
    dispatchGetTotalMonthExpense: (data,onSuccess, onError) => {
        dispatch(getTotalMonthExpense(data, onSuccess, onError))
    },
    dispatchGetTruckExpenses: (data,onSuccess, onError) => {
        dispatch(getTruckExpenses(data, onSuccess, onError))
    },
    dispatchGetTripExpenses: (data,onSuccess, onError) => {
        dispatch(getTripExpenses(data, onSuccess, onError))
    },
    dispatchGetOfficeExpenses: (data,onSuccess, onError) => {
        dispatch(getOfficeExpenses(data, onSuccess, onError))
    },
    dispatchGetAllVehicleExpense: (onSuccess, onFailure) => dispatch(getAllVehicleExpense(onSuccess, onFailure)),
    dispatchGetAllTripExpense: (onSuccess, onFailure) => dispatch(getAllTripExpenseTypes(onSuccess, onFailure)),
    dispatchGetAllOfficeExpenseTypes: (onSuccess, onFailure) => dispatch(getAllOfficeExpenseTypes(onSuccess, onFailure)),
    dispatchGetVendorExpense: (expenseId, onSuccess, onFailure) =>
    dispatch(getVendorExpense(expenseId, onSuccess, onFailure)),
    dispatchGetOfficeExpense: (expenseId, onSuccess, onFailure) =>
    dispatch(getOfficeExpenseSingle(expenseId, onSuccess, onFailure))
});
const ExpensesWithRouter = withRouter(Expenses);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExpensesWithRouter);
